"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Url = /** @class */ (function () {
    function Url() {
    }
    Url.prototype.baseURL = function (url) {
        var noQueryParametersURl = url.split('?')[0] || '';
        var res = noQueryParametersURl.match(/^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)(?:(:\d*)?)/g);
        if (res === null)
            return '';
        return res[0];
    };
    Url.prototype.getUrlParamsByName = function (uri, name) {
        var u = !(/\w+:\/\//).test(uri) ? "http://".concat(uri) : uri;
        var params = (new URL(u)).searchParams;
        return params.get(name);
    };
    return Url;
}());
exports.default = Url;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvdXRpbHMvdXJsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7SUFBQTtJQWNBLENBQUM7SUFiRyxxQkFBTyxHQUFQLFVBQVMsR0FBVztRQUNoQixJQUFNLG9CQUFvQixHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFBO1FBQ3BELElBQU0sR0FBRyxHQUFHLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxpRUFBaUUsQ0FBQyxDQUFBO1FBQ3pHLElBQUksR0FBRyxLQUFLLElBQUk7WUFBRSxPQUFPLEVBQUUsQ0FBQTtRQUUzQixPQUFPLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUNqQixDQUFDO0lBRUQsZ0NBQWtCLEdBQWxCLFVBQW9CLEdBQVcsRUFBRSxJQUFZO1FBQ3pDLElBQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLGlCQUFVLEdBQUcsQ0FBRSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUE7UUFDekQsSUFBTSxNQUFNLEdBQUcsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQTtRQUN4QyxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDM0IsQ0FBQztJQUNMLFVBQUM7QUFBRCxDQUFDLEFBZEQsSUFjQyJ9